import React from "react";

export default function GeneralPreview({ colors, theme }) {
  const t = colors?.[theme] || colors?.light_theme || {};

  const rows = [
    { id: 1, name: "João Silva", status: "Ativo", value: "R$ 1.200,00" },
    { id: 2, name: "Maria Souza", status: "Pendente", value: "R$ 850,00" },
    { id: 3, name: "Carlos Lima", status: "Inativo", value: "R$ 320,00" },
  ];

  return (
    <div className="card rounded w-100 shadow" style={{ background: t.bgPrimary || "#FFFFFF", fontFamily: "Inter, sans-serif" }}>
      <div className="card-header d-flex align-items-center justify-content-between" style={{ background: t.bgSecondary || "#F4F7FB", borderBottom: `1px solid ${t.borderPrimary || "#D6DEE8"}` }}>
        <span className="small fw-bold" style={{ color: t.textPrimary || "#1F3A5F" }}>Dashboard</span>
        <div className="d-flex gap-2">
          <div className="rounded-circle" style={{ width: 20, height: 20, background: t.themeTertiary || "#FF7A1A" }} />
          <div className="rounded-circle" style={{ width: 20, height: 20, background: t.textMuted || "#A5B1C2" }} />
        </div>
      </div>

      <div className="d-flex" style={{ minHeight: 300 }}>
        <div className="d-flex flex-column py-3 px-2" style={{ background: t.bgTertiary || "#E6EDF5", width: 90, borderRight: `1px solid ${t.borderPrimary || "#D6DEE8"}` }}>
          {["Início", "Usuários", "Config"].map((item, i) => (
            <div key={item} className="px-2 py-2 rounded" style={{ background: i === 1 ? t.bgCard || "#FFFFFF" : 'transparent', color: i === 1 ? t.textPrimary || "#1F3A5F" : t.textSecondary || "#5A6D85" }}>
              <small>{item}</small>
            </div>
          ))}
        </div>

        <div className="flex-grow-1 p-3" style={{ background: t.bgContent || "#F8FAFD" }}>
          <div className="row g-2">
            {[{ label: "Usuários", value: "1.245" }, { label: "Receita", value: "R$ 45k" }, { label: "Alertas", value: "3" }].map((card) => (
              <div className="col-12 col-md-4" key={card.label}>
                <div className="p-3 rounded" style={{ background: t.cards?.background || t.bgCard || "#fff", border: `1px solid ${t.borderSecondary || "#EDF2F9"}` }}>
                  <p className="small mb-1" style={{ color: t.cards?.subtitle || t.textSecondary || "#5A6D85" }}>{card.label}</p>
                  <p className="h6 fw-bold mb-0" style={{ color: t.cards?.value || t.themeTertiary || "#FF7A1A" }}>{card.value}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="d-flex gap-2 flex-wrap mt-3">
            <button className="btn btn-sm fw-semibold" style={{ background: t.buttons?.bgBtnPrimary || t.themePrimary || "#1F3A5F", color: t.buttons?.textPrimary || "#fff" }}>Primário</button>
            <button className="btn btn-sm fw-semibold" style={{ background: t.buttons?.bgBtnTertiary || t.themeTertiary || "#FF7A1A", color: t.buttons?.textSecondary || "#fff" }}>Laranja</button>
            <button className="btn btn-sm fw-semibold" style={{ background: t.buttons?.btnSuccess || t.statusSuccess || "#28A745", color: t.buttons?.textPrimary || "#fff" }}>Sucesso</button>
            <button className="btn btn-sm border" style={{ background: 'transparent', color: t.textPrimary || "#1F3A5F", borderColor: t.borderPrimary || "#D6DEE8" }}>Outline</button>
          </div>

          <div className="rounded mt-3 overflow-hidden" style={{ border: `1px solid ${t.borderPrimary || "#D6DEE8"}` }}>
            <table className="table mb-0 small">
              <thead>
                <tr style={{ background: t.tables?.headerBg || t.themePrimary || "#1F3A5F", color: '#fff' }}>
                  {["#", "Nome", "Status", "Valor"].map((h) => <th key={h} className="py-2">{h}</th>)}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, idx) => (
                  <tr key={row.id} style={{ background: idx % 2 === 0 ? t.tables?.rowBg || t.bgCard || '#FFFFFF' : t.tables?.rowBgAlt || t.bgSecondary || '#F4F7FB' }}>
                    <td className="py-2" style={{ color: t.tables?.text || t.textPrimary || "#1F3A5F" }}>{row.id}</td>
                    <td className="py-2" style={{ color: t.tables?.text || t.textPrimary || "#1F3A5F" }}>{row.name}</td>
                    <td className="py-2"><span className="badge" style={{ background: row.status === 'Ativo' ? '#28A74522' : row.status === 'Pendente' ? '#FF7A1A22' : '#DC354522', color: row.status === 'Ativo' ? t.statusSuccess || '#28A745' : row.status === 'Pendente' ? t.statusWarning || '#FF7A1A' : t.statusDanger || '#DC3545' }}>{row.status}</span></td>
                    <td className="py-2 fw-semibold" style={{ color: t.tables?.paginationText || t.themeTertiary || "#FF7A1A" }}>{row.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="d-flex justify-content-between align-items-center px-3 py-2" style={{ background: t.tables?.rowBg || t.bgCard || '#FFFFFF', borderTop: `1px solid ${t.borderPrimary || "#D6DEE8"}` }}>
              <small style={{ color: t.textMuted || '#A5B1C2' }}>3 registros</small>
              <div className="d-flex gap-1">
                {[1,2,3].map(p => (
                  <div key={p} className="rounded d-flex align-items-center justify-content-center" style={{ width: 24, height: 24, background: p===1 ? t.tables?.paginationText || t.themeTertiary || '#FF7A1A' : 'transparent', color: p===1 ? '#fff' : t.tables?.paginationText || t.themeTertiary || '#FF7A1A' }}>{p}</div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}